/* eslint-disable react-hooks/exhaustive-deps */
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import TextareaInput from '../../../components/UI/TextareaInput';
import PageLoader from '../../../components/loaders/PageLoader';
import { GET, PUT } from '../../../services/rest.service';

const FamilyView = () => {
  const [family, setFamily] = useState({});
  const [note, setNote] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();

  const getFamily = async () => {
    try {
      const family = await GET(`/admin/user/get_by_id/${id}`);
      setFamily(family.data);
      setNote(family.data.note);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getFamily();
  }, []);

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleNoteSave = async () => {
    const payload = {
      _id: family._id,
      type: 'note',
      value: note,
    };

    try {
      await PUT('/admin/family/requests/update', payload);
      toast.success('Notes added successfully!');
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (isEmpty(family)) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="h6 text-uppercase mb-0">
                  {family.first_name} {family.last_name}&nbsp;
                  {family.isEmailConfirmed && (
                    <Tooltip title="Email Verified" className={'c-pointer'} placement="top">
                      <CheckCircleIcon className={'text-success'} />
                    </Tooltip>
                  )}
                </h3>
                <button className="btn btn-outline-primary" onClick={() => navigate(`/admin/family/update/${family._id}`)}>
                  <i className="fas fa-pen"></i> Edit
                </button>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h4 className="text-400">Contact Info</h4>
                    <hr />
                  </div>

                  <div className="col-lg-4 col-xll-3">
                    <i className="fas fa-envelope mr-1"></i> {family.email}
                  </div>
                  <div className="col-lg-4 col-xl-3 col-xll-2">
                    <i className="fas fa-phone mr-1"></i> {family?.mobile_number}
                  </div>
                  <div className="col-lg-4 col-xll-3">
                    <i className="fas fa-map-marker-alt mr-1"></i> {family.location.address}
                  </div>
                  <div className="col-lg-4 col-xll-3">
                    <strong>Preferred Contact Method:</strong> {family.preferredContactMethod ? family.preferredContactMethod.replace(/_/g, ' ') : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {family.RequestedNanny && family.RequestedNanny.length > 0 && (
        <section className={'pb-5'}>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <h4 className="text-400">Requested Nannies</h4>
                      <hr />
                    </div>
                    {family.RequestedNanny.map((nanny, index) => {
                      return (
                        <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                          <div className={'card p-3 h-100 nannies-list'}>
                            <div className="media">
                              <div className="media-body align-self-center">
                                <h5 className="my-0">Requested On {moment(nanny.created_at.substring(0, 10)).format('MM/DD/YYYY')}</h5>
                              </div>
                            </div>
                            <hr />
                            <div>
                              <p>
                                <strong>Availability</strong>: {nanny.availability}
                              </p>
                              <p>
                                <strong>Children's Age</strong>: {nanny.children_age}
                              </p>
                              <p>
                                <strong>How soon to start</strong>: {nanny.how_soon_start}
                              </p>
                              <p>
                                <strong>Number of children</strong>: {nanny.no_of_children}
                              </p>
                              <p>
                                <strong>Place of Work</strong>: {nanny.place_of_work.address}
                              </p>
                              <p>
                                <strong>Start Date</strong>: {moment(nanny.start_date.substring(0, 10)).format('MM/DD/YYYY')}
                              </p>
                              <p>
                                <strong>Status</strong>: {nanny.status}
                              </p>
                              <p>
                                <strong>How transports children</strong>: {nanny.transport_children}
                              </p>
                              <p>
                                <strong>Requested Skills</strong>:
                                {nanny.skills.map((skill, index) => (
                                  <span key={index}>{skill.title}, </span>
                                ))}
                              </p>
                              <p>
                                {' '}
                                <strong>Additional Info:</strong> <br />
                                {nanny.additional_info}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {family.RequestedSitter && family.RequestedSitter.length > 0 && (
        <section className={'pb-5'}>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <h4 className="text-400">Requested Sitters</h4>
                      <hr />
                    </div>

                    {family.RequestedSitter.map((sitter, index) => {
                      return (
                        <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                          <div className={'card p-3 h-100 nannies-list'}>
                            <div className="media">
                              <div className="media-body align-self-center">
                                <h5 className="my-0">Requested On {moment(sitter.created_at).format('MM/DD/YYYY')}</h5>
                              </div>
                            </div>
                            <hr />
                            <div>
                              <p>
                                <strong>Children's Age</strong>: {sitter.children_age}
                              </p>
                              <p>
                                <strong>Have Pets?</strong>: {sitter.do_have_pets}
                              </p>
                              <p>
                                <strong>Free Parking?</strong>: {sitter.easy_free_parking}
                              </p>
                              <p>
                                <strong>End Time</strong>: {moment(sitter.needed_end_time).format('MM/DD/YYYY')}
                              </p>
                              <p>
                                <strong>Start Time</strong>: {moment(sitter.needed_start_time).format('MM/DD/YYYY')}
                              </p>
                              <p>
                                <strong>Number of children</strong>: {sitter.no_of_children}
                              </p>
                              <p>
                                <strong>Start Date</strong>: {moment(sitter.start_date).format('MM/DD/YYYY')}
                              </p>
                              <p>
                                <strong>Status</strong>: {sitter.status}
                              </p>
                              <p>
                                <strong>How Transports Children</strong>: {sitter.transport_children}
                              </p>
                              <p>
                                <strong>Types of Care</strong>: {sitter.types_of_care}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className={'pb-5'}>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="text-400">
                  Notes <small className={'text-light-grey'}>Last Edited: {family.note_last_edited ? moment(family.note_last_edited).format('MM/DD/YYYY') : 'N/A'}</small>{' '}
                </h4>
              </div>
              <div className="card-body">
                <div>
                  <TextareaInput id={'note'} name={'note'} rows={15} onChange={handleNoteChange} value={note} label={null} />
                </div>
                <div className={'form-group'}>
                  <button className="btn btn-primary" onClick={handleNoteSave}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FamilyView;
